import Parse from "parse";

Parse.initialize("asew");
Parse.serverURL = "https://parse-asew.apps.openinc.dev/parse";
